// 背景圖上傳前的檢查與縮圖。
// 背景圖每次開 viewer 都要下載，手機直出的大照片（4000px 以上、數 MB）會拖慢載入，
// 所以長邊超過 MAX_EDGE 時先在瀏覽器縮小再上傳；沒超過就原檔上傳，不重新壓縮。
// 後端（ModelService.uploadBackground）另有同樣的格式與 10MB 限制。
// 與 areditor/src/utils/backgroundImageFile.js 相同，改這裡要一起改。

export const ACCEPT_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const ACCEPT_ATTR = ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp";
const ACCEPT_EXTENSIONS = ["jpg", "jpeg", "png", "webp"];

export const MAX_EDGE = 2560;
export const MAX_BYTES = 10 * 1024 * 1024;

const extensionOf = (name) => {
  const dot = typeof name === "string" ? name.lastIndexOf(".") : -1;
  return dot < 0 ? "" : name.slice(dot + 1).toLowerCase();
};

// 回傳 i18n key；通過時回傳 null
export const validateBackgroundFile = (file) => {
  if (!file) return "backgroundInvalidType";
  if (!ACCEPT_TYPES.includes(file.type) || !ACCEPT_EXTENSIONS.includes(extensionOf(file.name))) {
    return "backgroundInvalidType";
  }
  return null;
};

// 等比例縮到長邊不超過 maxEdge（不放大）
export const getScaledSize = (width, height, maxEdge = MAX_EDGE) => {
  const longest = Math.max(width, height);
  if (!longest || longest <= maxEdge) return { width, height, scaled: false };
  const ratio = maxEdge / longest;
  return { width: Math.round(width * ratio), height: Math.round(height * ratio), scaled: true };
};

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });

// 回傳要上傳的檔案（可能是縮小後的新檔）；超過大小上限時 reject('backgroundTooLarge')
export const prepareBackgroundFile = async (file) => {
  const img = await loadImage(file);
  const { width, height, scaled } = getScaledSize(img.naturalWidth, img.naturalHeight);
  let result = file;
  if (scaled) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, file.type, 0.9));
    if (blob) result = new File([blob], file.name, { type: file.type, lastModified: Date.now() });
  }
  if (result.size > MAX_BYTES) throw new Error("backgroundTooLarge");
  return result;
};
